export class AzureScanningAccountSetupStatus200Response {
    'workflowId';
    'status';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return AzureScanningAccountSetupStatus200Response.attributeTypeMap;
    }
    constructor() {
    }
}
